// Constants
const youtubePlayer = require( 'youtube-player' );

var player,
    video;

const Video = {

    /**
     * Initialization
     */
    
    init() {
        //console.log('inited video')
        video = document.querySelector('.inspiration-video');
        var trigger = video.querySelector('.video-trigger'),
            src = video.dataset.vidsrc;

        player = youtubePlayer( 'player', {
            videoId: src
        });
        trigger.addEventListener('click', Video.videoPlay, false);
    },
    videoPlay() {
        video.classList.add('playing');
        event.preventDefault();
        player.playVideo();
    }
};

export default Video;



// WEBPACK FOOTER //
// ./src/js/components/video.js